<!--
================================================
Un composant qui affiche une ligne de tableau d'un timerecord en chargement (avec vue-content-loader https://github.com/egoist/vue-content-loader/).

Ce composant est appelé dans MyRecentActivityComp

(visible sur http://localhost:8080/fr/cronocloud-inc/timeclock)
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template class="LoadingTimerecordComp">
    <tr v-bind:class="{'darkMode':themeToDisplay=='dark'}" >
        <td class="timerecordPlaceholder">
            <content-loader
                    :height="16"
                    :speed="2"
                    :width="600"
                    :primaryColor="primaryColor"
                    :secondaryColor="secondaryColor"
            >
                <circle cx="96" cy="97.2" r="1" />
                <rect height="10" rx="6" ry="6" width="90" x="10" y="5" />
                <rect height="10" rx="6" ry="6" width="90" x="140" y="5" />
                <rect height="10" rx="6" ry="6" width="90" x="270" y="5" />
            </content-loader>
        </td>

    </tr>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>

    import { ContentLoader } from "vue-content-loader"
    import {mapState} from 'vuex'

    export default {
        name: 'LoadingTimerecordComp', //utile dans vue dev tool
        mixins: [],
        components: {ContentLoader},
        data: function () {
            return {
            }
        },
        computed:{
          ...mapState({
            themeToDisplay: state =>state.app.themeToDisplay

          }),

          primaryColor: {
              get: function () {
                switch (this.themeToDisplay) {
                  case  'dark': return '#3f4647'; break;
                  case  'light': return '#ecebeb'; break;
                }
              },
              set: function () {return null}
          },

          secondaryColor: {
            get: function () {
              switch (this.themeToDisplay) {
                case  'dark': return '#666'; break;
                case  'light': return '#f6f9f9'; break;
              }
            },
            set: function () {return null}
          }
        },

        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /*@import "../assets/css/globalVar.scss";*/
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/
    .LoadingTimerecordComp{

    }
</style>
